import FlexcarWordmark2024NoCircle from '@/icons/flexcar-wordmark-2024-no-circle';
import { cn } from '@/shadcn-ui/utils';
import { ReactNode } from 'react';

interface SavingsReceiptContainerProps {
  variant: 'buying' | 'flexcar';
  children: ReactNode;
}

export default function SavingsReceiptContainer({
  variant,
  children,
}: SavingsReceiptContainerProps) {
  return (
    <div
      className={cn(
        'flex flex-col rounded-[24px] border-[1px] border-solid border-flexcar-neutral80 shadow-[0px_0px_2px_2px_#FFF_inset]',
        {
          'bg-flexcar-neutral90': variant === 'buying',
          'bg-[linear-gradient(180deg,rgba(255,255,255,0.90)_0%,rgba(251,252,254,0.90)_100%)]':
            variant === 'flexcar',
        }
      )}
    >
      <div
        className={cn(
          'flex w-full flex-row items-center justify-center rounded-t-[24px] px-[8px] py-[12px]',
          {
            'bg-flexcar-neutral20': variant === 'buying',
            'bg-flexcar-blue30': variant === 'flexcar',
          }
        )}
      >
        {variant === 'buying' ? (
          <p className="body2-strong text-center tracking-[2.8px] text-flexcar-neutral100">
            BUYING
          </p>
        ) : null}
        {variant === 'flexcar' ? <FlexcarWordmark2024NoCircle /> : null}
      </div>
      {children}
    </div>
  );
}
